
jQuery(document).ready(function () {

  jQuery('.heading-title-class').on('click', function () {
    if (jQuery(window).width() < 768) {
      jQuery(this).toggleClass("active");
      jQuery(this).next().toggle();
    }
  });
  $('.min-what-block .title-what-kla').matchHeight();
  $('.block-item-refur .title-item').matchHeight();
  $('.block-item-refur .content-item').matchHeight();
  $('.home-product-list .swatch-home').matchHeight();

  $(".read-more").click(function () {
    if ($(".text-seo").hasClass("show-more-height")) {
      $(this).text("Read Less");
    } else {
      $(this).text("Read More");
    }

    $(".text-seo").toggleClass("show-more-height");
  });
  if (window.matchMedia("(max-width: 768px)").matches) {
    // $('.slider-blog-home [data-label="Article List"] .gf_row .gf_clearfix').remove();
    $('.article-list').addClass("owl-carousel");
    $('.article-list').owlCarousel({
      nav: true, // Show next and prev buttons
      slideSpeed: 300,
      paginationSpeed: 400,
      items: 1,
      loop: true
    })
  } else {
    $('.article-list').removeClass("owl-carousel");
  }

  window.onorientationchange = function () {
    var orientation = window.orientation;
    switch (orientation) {
      case 0:
      case 90:
      case -90: window.location.reload();
        break;
    }
  };

  setBlogListSlider();

  // ================= Color swatch ====================
  function capitalizeWords(sentence) {
    return sentence.split(' ') // Split sentence into an array of words
      .map(word => {
        // Capitalize the first letter of each word
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' '); // Join the words back with spaces
  }

  const targetNode = document.getElementById('SiteNav');

  // ======== Phone Parts menu item ============
  if (!window.customerTags.includes("b2b") && !window.customerTags.includes("both")) {
    // 1. Function to find and hide the specific item
    const hidePhoneParts = () => {
      $('#SiteNav .gm-item.gm-level-0').filter(function () {
        return $(this).find('.gm-target').first().text().trim() === "Phone Parts";
      }).hide();
    };

    // 2. Run immediately in case it's already there
    hidePhoneParts();

    // 3. Set up the Observer
    if (targetNode) {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            hidePhoneParts();
          }
        }
      });

      // Start observing for changes in children/sub-tree
      observer.observe(targetNode, { childList: true, subtree: true });
    }
  }


  // ======== Color swatch ========
  const inners = document.querySelectorAll('.main-swatches .option-item-inner[option-name="Colour"]')

  for (let inner of inners) {
    const valueWrapper = inner.children[0];
    const textEl = document.createElement('div');
    textEl.textContent = capitalizeWords(inner.getAttribute('option-name-value').replace('-', ' '))
    textEl.classList.add("option-value-text");
    valueWrapper.appendChild(textEl);
  }

  // ======================== Total Price ========================

  const quantityInputSelector = '.main-product-quantity input';
  const unitPriceSelector = '.main-product-price';

  function parsePriceByFormat(priceString, format) {
    if (!priceString) return 0;

    // 1. Identify the non-numeric part of the format (the "wrapper")
    // For "£", the prefix is "£"
    const prefix = format.split('\{\{')[0];
    const suffix = format.split('\}\}')[1] || '';

    // 2. Remove the prefix and suffix from the actual price text
    let valueOnly = priceString.replace(prefix, '').replace(suffix, '');

    // 3. Remove commas (thousands separators) and keep the decimal point
    // This turns "1,250.00" into "1250.00"
    valueOnly = valueOnly.replace(/,/g, '');

    return parseFloat(valueOnly) || 0;
  }

  const updateCalculation = () => {
    setTimeout(() => {
      const qtyInput = document.querySelector(quantityInputSelector);
      const unitPriceElement = document.querySelector(unitPriceSelector);
      const totalDisplay = document.querySelector('.total-price');

      if (!qtyInput || !unitPriceElement || !totalDisplay) return;

      // 1. Get Quantity
      const qty = parseInt(qtyInput.value) || 1;

      // 2. Get Unit Price (removes currency symbols/commas)
      const moneyFormat = JSON.parse(unitPriceElement.getAttribute("gp-data")).moneyFormat;
      const rawPrice = parsePriceByFormat(unitPriceElement.innerText, moneyFormat);
      const price = parseFloat(rawPrice);

      // 3. Calculate and Format
      const total = price * qty;

      // 4. Update the display (assuming USD '$' - change if needed)
      totalDisplay.innerText = moneyFormat.replace('\{\{amount\}\}', total.toFixed(2));
    });
  };

  // Listen for Quantity changes
  document.addEventListener('input', (e) => {
    if (e.target.closest(quantityInputSelector)) {
      updateCalculation();
    }
  });

  // Listen for Variant changes 
  // GemPages/Shopify usually updates the price text when a variant changes.
  // We use a MutationObserver to detect when that price text changes.
  const priceNode = document.querySelector(unitPriceSelector);
  if (priceNode) {
    const observer = new MutationObserver(updateCalculation);
    observer.observe(priceNode, { characterData: true, childList: true, subtree: true });
  }

  // Initial calculation on load
  updateCalculation();

  // ======================== Condition Preview ========================

  const conditionMap = {
    'excellent': {
      images: [
        {
          text: 'Closest to new. May have micro scratches.',
          src: 'https://cdn.shopify.com/s/files/1/0995/6773/1020/files/image.png?v=1766490384',
        },
        {
          text: 'Flawless, no wear signs.',
          src: 'https://cdn.shopify.com/s/files/1/0995/6773/1020/files/image_1.png?v=1766490383',
        }
      ]
    },
    'good': {
      images: [
        {
          text: 'Has light signs of wear and use.',
          src: 'https://cdn.shopify.com/s/files/1/0560/8951/0078/files/image_267679a1-b1d9-4929-a46f-fa82206fdb46.png?v=1773667326',
        },
        {
          text: 'Flawless, no wear signs.',
          src: 'https://cdn.shopify.com/s/files/1/0995/6773/1020/files/image_2.png?v=1766490443'
        }
      ],
    },
    'average': {
      images: [
        {
          text: 'Visible use & wear signs (scratches & dents).',
          src: 'https://cdn.shopify.com/s/files/1/0995/6773/1020/files/image_4.png?v=1766490552',
        },
        {
          text: 'Has small scratches.',
          src: 'https://cdn.shopify.com/s/files/1/0995/6773/1020/files/image_5_9fc074a4-069a-4442-9d86-619f4387db57.png?v=1766490551'
        }
      ]
    }
  };

  const collectionPreviewImages = window.collectionPreviewImages || {};


  let matchedHandle = null;
  const collectionsToCheck = Object.keys(window.collectionPreviewImages || {});

  if (window.productCollections && Array.isArray(window.productCollections)) {
    for (const handle of collectionsToCheck) {
      if (window.productCollections.includes(handle) && collectionPreviewImages[handle]) {
        matchedHandle = handle;
        break;
      }
    }
  }


  if (matchedHandle) {
    const customMap = collectionPreviewImages[matchedHandle];
    if (customMap.excellent && customMap.excellent.images && customMap.excellent.images.length > 0) {
      conditionMap.excellent = customMap.excellent;
    }
    if (customMap.good && customMap.good.images && customMap.good.images.length > 0) {
      conditionMap.good = customMap.good;
    }
    if (customMap.average && customMap.average.images && customMap.average.images.length > 0) {
      conditionMap.average = customMap.average;
    }
  }


  const getCondition = () => $('.main-swatches [variant-option-name="Condition"] .option-item-active .option-value ').text().trim();

  const handleConditionModalNav = (modal, data) => {
    $(document.body).css('overflow', 'hidden');

    let currentIndex = 0;

    modal.find('.close').click(function () {
      modal.remove();
      $(document.body).css('overflow', 'auto');
    })

    const scrollToImage = (index) => {
      const container = modal.find('.preview-container');
      const width = container.width();
      container.animate({
        scrollLeft: index * width
      }, 300);
    }

    const toggleNav = () => {
      if (currentIndex === data.images.length - 1) {
        modal.find('.next').removeClass('active');
      } else {
        modal.find('.next').addClass('active');
      }

      if (currentIndex === 0) {
        modal.find('.back').removeClass('active');
      } else {
        modal.find('.back').addClass('active');
      }

      modal.find('.images img').each(function (index) {
        const el = $(this);
        if (currentIndex === index) {
          el.addClass('active');
        } else {
          el.removeClass('active');
        }
      })

    }

    modal.find('.next').click(function () {
      if (currentIndex < data.images.length - 1) {
        currentIndex++;
        scrollToImage(currentIndex);
        toggleNav();
      }
    });

    modal.find('.back').click(function () {
      if (currentIndex > 0) {
        currentIndex--;
        scrollToImage(currentIndex);
        toggleNav();
      }
    })

    modal.find('.images img').click(function () {
      const el = $(this);
      currentIndex = modal.find('.images img').index(el);
      scrollToImage(currentIndex);
      toggleNav();
    })

    toggleNav();
  }

  $('#preview-condition-button').click(function () {
    const condition = getCondition();
    const data = conditionMap[condition.toLowerCase()];
    const isAudio = window.productCollections && window.productCollections.includes('audio');
    const isAppleWatch = window.productCollections && window.productCollections.includes('refurbished-apple-watch');
    const conditionTitle = isAudio ? 'Airpods Condition' : (isAppleWatch ? 'Smartwatch Condition' : 'Phone Condition');

    const modal = $(`
      <div id="preview-condition-modal" class="condition-modal">
        <div class="custom-modal">
            <div class="header">
                <div class="title">${conditionTitle} - ${condition}</div>
                <button class="close">
                  <img src="https://cdn.shopify.com/s/files/1/0995/6773/1020/files/bx_x.svg?v=1766478300" />
                </button>
            </div>
            <div class="body">
                <button class="nav back">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5 5.25L8.75 14L17.5 22.75" stroke="#D9DBE1" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                 <button class="nav next active">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 5.25L19.25 14L10.5 22.75" stroke="#D9DBE1" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <div class="preview-container">
                  ${data.images.map(image => `<img class="preview-image" src="${image.src}" />`).join('')}
                </div>
            </div>
            <div class="images">
              ${data.images.map((image, index) => `
                <img src=${image.src} class="${index === 0 ? 'active' : ''}"/>
              `).join('')}
            </div>
        </div>
    </div>
      `)
    $(document.body).append(modal);

    const body = modal.find('.body');
    // body.height(body.width());

    handleConditionModalNav(modal, data);
  })

  const handleSubmitButton = (btn) => {
    const originalClick = btn.get(0).click

    const overrideClick = function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();

      const condition = getCondition();
      const data = conditionMap[condition.toLowerCase()];

      const modal = $(`
        <div id="confirm-condition-modal" class="condition-modal">
          <div class="custom-modal">
              <div class="header">
                  <div class="title">Please review the condition you’re buying.</div>
                  <button class="close">
                    <img src="https://cdn.shopify.com/s/files/1/0995/6773/1020/files/bx_x.svg?v=1766478300" />
                  </button>
              </div>
              <div class="description">
                Would you like to upgrade or downgrade your selection?
              </div>
              <div class="body">
                  <div class="sample">Sample image</div>
                  <button class="nav back">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.5 5.25L8.75 14L17.5 22.75" stroke="#D9DBE1" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <button class="nav next active">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.5 5.25L19.25 14L10.5 22.75" stroke="#D9DBE1" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <div class="preview-container">
                    ${data.images.map(image => `<img class="preview-image" src="${image.src}" />`).join('')}
                  </div>
              </div>
              <div class="buttons">
                <button class="confirm">Confirm & Continue</button>
                <button class="cancel">View another condition</button>
              </div>
          </div>
      </div>
        `)
      $(document.body).append(modal);

      const body = modal.find('.body');

      handleConditionModalNav(modal, data);

      const close = () => {
        modal.remove();
        $(document.body).css('overflow', 'auto');
      }

      modal.find('.confirm').click(function () {
        btn.off('click');
        btn.get(0).click = originalClick;
        btn.get(0).click();
        btn.on('click', overrideClick);
        close();
      })

      modal.find('.cancel').click(function () {
        close();
      })
    }

    btn.on('click', overrideClick);
  }

  if ($('.main-swatches [variant-option-name="Condition"]').length > 0) {
    handleSubmitButton($('.add-to-cart[name="add"]'))
    handleSubmitButton($('.buy-now'))
  }

  // ======================== Estimated delivery ========================
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      onUrlChange(false);
    }
  }).observe(document, { subtree: true, childList: true });

  function isWeekend(date) {
    const dayOfWeek = date.day();
    // In most locales, Sunday is 0 and Saturday is 6
    return dayOfWeek === 0 || dayOfWeek === 6;
  }

  function addBusinessDays(start, daysToAdd) {
    let date = start.clone();
    let addedDays = 0;

    while (isWeekend(date)) {
      date = date.add(1, 'day');
    }

    while (addedDays < daysToAdd) {
      // Add one day at a time
      date = date.add(1, 'day');

      if (!isWeekend(date)) {
        addedDays++;
      }
    }

    return date;
  }

  function onUrlChange(isInitialLoad) {
    const estimatedEl = $('#estimated-delivery-date');

    if (estimatedEl.length === 0) {
      return;
    }

    const estimatedTextEl = estimatedEl.find('.text');
    const addToCartButtons = $('button[name="add"]');
    const mainPrice = $('.main-product-price');
    const isOutOfStock = addToCartButtons.length > 0 && addToCartButtons.filter(':not(:disabled)').length === 0;
    const isUnavailable = mainPrice.length > 0 && mainPrice.height() === 0;

    if (isOutOfStock || isUnavailable) {
      estimatedEl.css("display", "none");
    } else {
      estimatedEl.css("display", "flex");
    }

    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    const variants = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.variants;
    const variant = variants ? (variants.find(v => v.id.toString() === variantId) || variants[0]) : null;

    const sku = (variant && variant.sku) || "";
    const hasDRP = sku.includes('DRP');

    const today = dayjs();
    const t2 = addBusinessDays(today, 3).format('DD MMM');
    const t5 = addBusinessDays(today, 7).format('DD MMM');

    if (hasDRP) {
      estimatedTextEl.text(`Estimated delivery by ${t2} - ${t5}`)
    } else {
      estimatedTextEl.text(`Estimated delivery by ${t2}`)
    }
  }

  onUrlChange(true);
  setTimeout(() => onUrlChange(true), 500);
  setTimeout(() => onUrlChange(true), 1500);

  // FAQ
  document.querySelectorAll('.gp-accordion-header').forEach(button => {
    button.addEventListener('click', () => {
      const accordionItem = button.parentElement;
      const panel = button.nextElementSibling;
      const isExpanded = accordionItem.classList.contains('is-active');

      // Toggle current item
      if (!isExpanded) {
        accordionItem.classList.add('is-active');
        panel.style.maxHeight = panel.scrollHeight + "px";
      } else {
        accordionItem.classList.remove('is-active');
        panel.style.maxHeight = "0px";
      }
    });
  });

  // Estimated delivery date

  const mainPriceObserver = new MutationObserver((mutationsList) => {
    const totalPriceEl = $('.total-price').parent()
    const mainPrice = $('.main-product-price');

    if (mainPrice.length > 0 && mainPrice.height() > 0) {
      // variant is available
      totalPriceEl.show();
    } else {
      // variant is unavailable
      totalPriceEl.hide();
    }
    onUrlChange(false);
  });

  // Start observing for changes
  const mainPrice = document.querySelector('.main-product-price');
  const addToCartButton = document.querySelector('button[name="add"]');

  if (mainPrice) {
    mainPriceObserver.observe(mainPrice, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (addToCartButton) {
    mainPriceObserver.observe(addToCartButton, {
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });
  }
});

$(window).on("load", function () {
  $('#SiteNav .gm-submenu .gm-grid ~ p').hide();
});

function setBlogListSlider() {

  if ($('body').hasClass('pg-blog-article-listing')) {

    var simpleSlide = $('.article-category .blogs_carousel');


    enquire.register("screen and (max-width: 749px)", {
      match: function () {
        //         console.log('==========================================');
        //         console.log('=================MATCH==================');
        //         console.log('==========================================');
        simpleSlide.addClass("owl-carousel");
        simpleSlide.owlCarousel({
          nav: true, // Show next and prev buttons
          slideSpeed: 300,
          paginationSpeed: 400,
          items: 1,
          loop: true
        }); // created
        // $('.article-category .col-lg-4').slick();
      },
      unmatch: function () {
        //         console.log('==========================================');
        //         console.log('=================UNMATCH==================');
        //         console.log('==========================================');
        simpleSlide.owlCarousel('destroy'); // destroyed
        // $('.article-category .col-lg-4').slick('unslick');
      }

    });

    enquire.register("screen and (max-width: 768px)", {
      match: function () {
        //         console.log('==========================================');
        //         console.log('=================MATCH==================');
        //         console.log('==========================================');
        simpleSlide.addClass("owl-carousel");
        simpleSlide.owlCarousel({
          nav: true, // Show next and prev buttons
          slideSpeed: 300,
          paginationSpeed: 400,
          items: 2,
          loop: true
        }); // created
        // $('.article-category .col-lg-4').slick();
      },
      unmatch: function () {
        //         console.log('==========================================');
        //         console.log('=================UNMATCH==================');
        //         console.log('==========================================');
        simpleSlide.owlCarousel('destroy'); // destroyed
        // $('.article-category .col-lg-4').slick('unslick');
      }

    });
  }
}

